export const GRANTED_TYPE = 'granted';

export const DENIED_TYPE = 'denied';

export const NOT_SUPPORTED = 'not-supported';

export const SUBSCRIBED = 'subscribed';

const getCurrentSubscription = async (reg) => {
  try {
    if (!reg.pushManager) {
      console.info('PushManager not available – user may have blocked notifications.');
      return null; // expected, not an error
    }

    return await reg.pushManager.getSubscription();
  } catch (err) {
    console.error('Unexpected error while fetching subscription:', err);
    throw err; // only real errors bubble up
  }
};

const setupUserPermissionsForNotification = async () => {
  if (typeof Notification === 'undefined') {
    console.warn('Browser does not support notifications.');
    return null;
  }

  let status = await Notification.requestPermission();

  if (status === DENIED_TYPE) {
    window.notification_status = DENIED_TYPE;
  } else if (status === GRANTED_TYPE) {
    window.notification_status = GRANTED_TYPE;
  }

  return window.notification_status;
};

const showNotification = (title, body = '') => {
  let icon = new URL('/resources/img/logo.png', import.meta.url).href;

  if (window.notification_status === GRANTED_TYPE) {
    new Notification(title, {
      body: body,
      icon: icon,
    });
  }
};

const checkCurrentDeviceSubscription = async () => {
  if (typeof Notification == 'undefined' || !('serviceWorker' in navigator)) {
    return NOT_SUPPORTED;
  }

  return await setupUserPermissionsForNotification();
};

const isDeviceSubscribe = (subscription) => {
  // Defensive checks
  if (!subscription || !subscription.endpoint || !window.device_endpoint?.endpoint) {
    return false;
  }

  let browser = getBrowserName() + '/' + getOS();
  console.log(browser);

  return subscription.endpoint === window.device_endpoint.endpoint;
};

const getBrowserName = () => {
  if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) != -1)
    return 'Opera';
  else if (navigator.userAgent.indexOf('Chrome') != -1) return 'Chrome';
  else if (navigator.userAgent.indexOf('Safari') != -1) return 'Safari';
  else if (navigator.userAgent.indexOf('Firefox') != -1) return 'Firefox';
  else if (navigator.userAgent.indexOf('MSIE') != -1 || !!document.documentMode == true)
    return 'IE';
  else return 'Unknown';
};

const getWorkerState = (reg) => {
  if (reg.waiting) return 'waiting';
  if (reg.installing) return 'installing';
  if (reg.waiting) return 'waiting';
  if (reg.active) return reg.active.state;
};

const urlBase64ToUint8Array = (base64string) => {
  const padding = '='.repeat((4 - (base64string.length % 4)) % 4);
  const base64 = (base64string + padding).replace(/\-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

const subscribeToPushNotifications = (reg) => {
  let dfd = $.Deferred();
  const subscribeOptions = {
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(
      'BBF3FCfDM5d_GqousXr1mYZjbUBw8T-A6BmBKe2L9VVo-0OCGgWzM3Isy0eyWJszTIkxSnj8jSdxKN-lQeCGhxA',
    ),
  };

  reg.pushManager
    .subscribe(subscribeOptions)
    .then(function (subscription) {
      window.device_endpoint = subscription;
      dfd.resolve(subscription);
    })
    .catch(function (err) {
      // Suppress the NotAllowedError (user denied notifications)
      if (err && err.name === 'NotAllowedError') {
        console.log('User denied notification permission. Skipping subscription.', err);
        // resolve gracefully instead of rejecting
        dfd.resolve(null);
      } else {
        console.error('Push subscription failed:', err);
        dfd.reject(err);
      }
    });
  return dfd.promise();
};

const checkWorkerRegistration = () => {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) {
    return Promise.resolve({ registered: false });
  }

  return navigator.serviceWorker.getRegistrations().then((registrations) => {
    let found = false;

    registrations.forEach((reg) => {
      window.device_state = getWorkerState(reg);
      if (reg.active?.scriptURL?.includes(window.ServiceWorker)) {
        found = true;
        window.device_state = getWorkerState(reg);
        window.device_registration = reg;
      }
      if (reg && reg.pushManager) {
        reg.pushManager
          .getSubscription()
          .then((subscription) => {
            if (subscription) {
              window.device_endpoint = subscription;
            } else {
              subscribeToPushNotifications(reg);
            }
          })
          .catch((err) => {
            console.error('Error getting push subscription:', err);
          });
      }
    });

    return { registered: found };
  });
};

const getOS = () => {
  let userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('macintosh') !== -1) {
    return 'Mac';
  }

  if (userAgent.indexOf('windows') !== -1) {
    return 'Windows';
  }

  if (userAgent.indexOf('android') !== -1) {
    return 'Android';
  }

  if (userAgent.indexOf('iphone') !== -1) {
    return 'Iphone';
  }

  return 'Unknown';
};

const isDesktop = () => {
  return (
    !navigator.userAgent.match(/Mobi/i) &&
    !navigator.userAgent.match(/Android/i) &&
    !navigator.userAgent.match(/iPhone/i)
  );
};

export {
  setupUserPermissionsForNotification,
  showNotification,
  checkCurrentDeviceSubscription,
  isDeviceSubscribe,
  getBrowserName,
  urlBase64ToUint8Array,
  subscribeToPushNotifications,
  checkWorkerRegistration,
  getOS,
  isDesktop,
};
